import { moduleProviderFactory } from "core/providers";
import { NikoFacilityOrderInitialIntakePreview } from "application/niko-facility-order-initial-intake/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.niko-facility-order",
                pattern: "/niko-facility-orders",
                children: [
                    {
                        name: "master.app.main.niko-facility-order.initial-intake-preview",
                        pattern: "/:id/initial-intake",
                        authorization: "administrationSection.read",
                        component: NikoFacilityOrderInitialIntakePreview,
                        data: {
                            //title: "",
                            crumbs: [
                                {
                                    title: "NIKO_FACILITY_ORDER.CRUMB.INITIAL_INTAKE",
                                    route: 'master.app.main.niko-facility-order.initial-intake-preview'
                                }
                            ],
                            back: "master.app.main.niko-facility-order.list",
                        }
                    }
                ]
            }
        ],
        menu: [
            {
                title: "MENU.FACILITY_ORDERS",
                icon: "package",
                authorization: "administrationSection.read",
                order: 5,
                subMenu: [
                    {
                        title: "MENU.NIKO_FACILITY_ORDERS",
                        authorization: "administrationSection.read",
                        route: "master.app.main.niko-facility-order.list",
                        order: 3,
                    }
                ]
            },
        ]
    });
})();